import * as React from "react";
import Footer from "./Footer";
const OwlCarousel = require("react-owl-carousel").default;

import About from "./About";
import ContactUs from "./ContactUs";
import HomeContent from "./HomeContent";

import {Container,Row, Col} from "reactstrap";
const slide7 = require('../images/first.jpg');
const slide8 = require('../images/two.jpg');
const slide9 = require('../images/three.jpg');



/**
 * 
 * 
 * @export
 * @class App
 * @extends {React.Component<{}, {}>}
 */
export default class HomeSlide extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);       
    }
    render() {
        return (           
            <Container className = "header-container">
            
                <Row>
                    <OwlCarousel className="owl-theme" items= {1}
                        loop >
                        <div >
                            <img 
                                src= {slide7}
                                width= "10%"
                            />
                        </div>
                        <div >
                            <img 
                                src= {slide8}
                                width= "10%"
                            />
                        </div>
                        <div >
                            <img 
                                src= {slide9}
                                width= "10%"
                            />
                        </div>                      
                    </OwlCarousel>
                </Row>
                <HomeContent/>
                <About />
                <ContactUs />
                <Footer /> 
                
            </Container>           
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/views/Home.tsx